var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgHn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0zm203.491-104.377l4.421 13.605h14.305l-11.574 8.408 4.421 13.604-11.573-8.408-11.572 8.408 4.421-13.604-11.574-8.408h14.305zm0 59.361l4.421 13.606h14.305l-11.574 8.406 4.421 13.605-11.573-8.408-11.572 8.408 4.421-13.605-11.574-8.406h14.305zm105.018-59.361l4.42 13.605h14.305l-11.574 8.408 4.421 13.604-11.572-8.408-11.573 8.408 4.421-13.604-11.574-8.408h14.305zm0 59.361l4.42 13.606h14.305l-11.574 8.406 4.421 13.605-11.572-8.408-11.573 8.408 4.421-13.605-11.574-8.406h14.305zM256 238.191l4.421 13.605h14.304l-11.573 8.408 4.421 13.605L256 265.401l-11.573 8.408 4.421-13.605-11.573-8.408h14.304z",
  fill: "#338af3"
})));

export default SvgHn;